import React, { Component } from 'react';
import _omit from 'lodash.omit';
import _get from 'lodash.get';
import FileSaver from 'file-saver';
import { ROLE_MAP } from '@shootsta/common-domain-data';
import { getStringValueFromGenericInput } from '@shootsta/get-value-from-generic-input';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { QRCodeCanvas } from '@cheprasov/qrcode';
import { Button, FormModal, Input, COLOURS, NUMERIC_MEDIA_SIZES } from '../../../../../ui-kit';
import Iris from '../../../../../assets/images/logo-iris.svg';
import SharingSettings from './SharingSettings';
import getSharingUrl from '../utils/getSharingUrl';

import '../styles/_share-modal.scss';
















function downloadQRCode(url) {
  return async () => {
    const qrCanvas = new QRCodeCanvas(
      url,
      {
        fgColor: COLOURS.grey.denim,
        image: {
          source: Iris,
          width: '15%',
          height: '15%',
          x: 'center',
          y: 'center'
        }
      }
    );
    const dataUrlWithQRCode = await qrCanvas.toDataUrl();

    FileSaver.saveAs(dataUrlWithQRCode, 'qr-code.png');
  };
}

export default class ShareModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      copied: false
    };
  }

  onCopySuccess = () => {
    this.setState({ copied: true }, () => {
      setTimeout(() => {
        this.setState({ copied: false });
      }, 2000);
    });
  };

  onUpdateShareSetting = (shareSettings) => {
    const { onChangeLinkShareSettings } = this.props;

    onChangeLinkShareSettings(shareSettings);
  };

  changeAccessPermission = (result) => {
    const { onChangeLinkShareSettings, roles } = this.props;
    const selectedRole = roles.
    find(({ description }) => description === getStringValueFromGenericInput(result));

    onChangeLinkShareSettings({ role: _omit(selectedRole, ['description', '__typename']) });
  };

  handleOnClose = () => {
    const { onClose } = this.props;

    onClose();
  };

  handleOnSave = (inputUrl) => async () => {
    const {
      onSaveLinkSharingSettings,
      onChangeLinkShareSettings,
      linkSharingSettings,
      roles
    } = this.props;

    try {
      const {
        publicSettings: { role, resourceRoleAssignmentId: publicResourceRoleAssignmentId }
      } = linkSharingSettings || {};

      const roleName = _get(role, 'name');

      if (!publicResourceRoleAssignmentId && roleName === ROLE_MAP.NONE) {
        const guestRole = roles.find((r) => _get(r, 'name') === ROLE_MAP.GUEST) ||
        roles.find((r) => /guest/i.test(_get(r, 'description', '')));

        if (guestRole && onChangeLinkShareSettings) {
          // Ensure the role object shape matches other usages (omit description/meta)
          await onChangeLinkShareSettings({ role: _omit(guestRole, ['description', '__typename']) });
        }
      }
    } catch (e) {

      // Fail silently — copying should still attempt to proceed.
    }
    navigator.clipboard.writeText(inputUrl);
    this.onCopySuccess();

    await onSaveLinkSharingSettings(inputUrl);
  };

  render() {
    const {
      resourceName,
      visible,
      linkSharingSettings,
      roles,
      shareUrl
    } = this.props;

    const { copied } = this.state;

    const {
      publicSettings: { role, resourceRoleAssignmentId: publicResourceRoleAssignmentId }
    } = linkSharingSettings || {};

    const inputUrl = getSharingUrl({
      shareUrl,
      location: window.location,
      isPublic: Boolean(publicResourceRoleAssignmentId && _get(role, 'name') !== ROLE_MAP.NONE)
    });
    const copyLinkSaveText = `Copy ${resourceName} Link`;
    const isMediumWindowSize = window.screen.width < NUMERIC_MEDIA_SIZES.medium;
    const tabletCopyLinkTitle = isMediumWindowSize && copyLinkSaveText;

    return (
      <div className="share-modal-container">
        <FormModal
          visible={visible}
          onClose={this.handleOnClose}
          className="share-modal share-modal-advanced"
          title={`Share ${resourceName}`}
          saveText={copyLinkSaveText}
          onSave={this.handleOnSave(inputUrl)}
          footerChildren={
          <div className="share-modal__body__copy__action">
              <Button
              type="TERTIARY"
              prefix="qrcode"
              className="share-modal__body__copy__action__btn"
              tooltipId="save-qr-btn"
              tooltipLabel="Generate QR code"
              onClick={downloadQRCode(inputUrl)}
              data-cy="share-modal-qr-btn"
              isFullWidth={isMediumWindowSize}>

                <span className="share-modal__body__copy__title">
                  Generate QR Code
                </span>
              </Button>
            </div>}>


          <div className="share-modal__body">
            <div>
              <div className="share-modal__body__copy">
                <Input
                  defaultValue={inputUrl}
                  key={inputUrl}
                  className="share-modal__url"
                  disabled />

                <CopyToClipboard
                  text={inputUrl}
                  onCopy={this.onCopySuccess}>

                  <div className="share-modal__body__copy__action">
                    <Button
                      className="share-modal__body__copy-btn"
                      type="TERTIARY"
                      prefix={copied ? 'success' : 'duplicate'}
                      disabled={copied}
                      isFullWidth={isMediumWindowSize}
                      tooltipId="copy-link-btn"
                      tooltipLabel="Copy link"
                      onClick={this.handleOnSave(inputUrl)}>

                      {tabletCopyLinkTitle}
                    </Button>
                  </div>
                </CopyToClipboard>
              </div>
              <SharingSettings
                shareSettings={linkSharingSettings}
                onUpdateShareSetting={this.onUpdateShareSetting}
                roles={roles} />

            </div>
          </div>
        </FormModal>
      </div>);

  }
}